import React from 'react';
import axios from 'axios';
import {
	SfcShell,
	SfcShellAppBar
} from '@waypoint/react-components/dist/sfc-components';
import { SdfPageLayout } from '@waypoint/react-components';
import LeftNav from './left-nav';
import BaseRoutes from '../BaseRoutes';
import InitialsAvatarIcon from './topNavBarIcons/initialsAvatarIcon';
import SessionIndicator from '../layout/sideNavBar/sessionIndicator';
import {setExpiresAt, useApplicationState} from '../../utilities/applicationState';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Changed from useHistory
import TopMenuOptions from './topNavBarIcons/topMenuOptions';
import ToastList from '../toastList';
import { getEnvRootPath } from '../common/util';
import MarketplaceAssist from '../MarketplaceAssist';

const expiresAtArr = [];
const pathKey = 'lastPath';
const baseName = getEnvRootPath();

// use credentials
axios.defaults.withCredentials = true;
if (!axios.interceptors.response.handlers.length) {
	// use axios interceptor to intercept all responses.
	axios.interceptors.response.use(response => {
		const {headers: {'x-session-expires-at': expiresAt}} = response;
		if(expiresAt){
				// set the expiresAt in session.
				expiresAtArr.unshift(expiresAt)
				sessionStorage.removeItem('sessionExpired');
		}
		return response;
	}, error => {
		console.log('response status: ', error.response.status);
		if (window.location.pathname !== `${baseName}/login`) {
			if (error.response.status === 401) {
				// store the last location before redirecting to login.
				window.localStorage.setItem(pathKey, window.location.pathname.slice(baseName.length));

				console.info("window.location", window.location.pathname);
				console.error('401 received redirecting to login page..');
				window.location.href = import.meta.env.VITE_API_PATH.indexOf('https') === 0
					? `${import.meta.env.VITE_API_PATH}/authenticate`
					: `https://${import.meta.env.VITE_DOMAIN + import.meta.env.VITE_API_PATH}/authenticate`;
			} else {
				throw(error);
			}
		} else {
			console.log('Ignoring session error on login page.');
		}
	});
}

export default function OneuxLayout() {
	const [ , dispatch] = useApplicationState();
	const navigate = useNavigate(); // Changed from useHistory

	useEffect(()=> {
		// restore the previous location if available.
		const lastPath = window.localStorage.getItem(pathKey);
		if (lastPath) {
			if (lastPath !== '/') navigate(lastPath, { replace: true });
			window.localStorage.removeItem(pathKey);
		}
	}, [navigate])

	useEffect(()=>{
		if(expiresAtArr.length > 0){
			dispatch(setExpiresAt(expiresAtArr[0]));
			expiresAtArr.pop();
		}
	},[])

	return (
		<SfcShell>
			<SfcShellAppBar slot="app-bar" size="default">
				<div className="logo-divider no-branding"></div>
				<div className="branding-area font-semibold">API Central</div>
				<div className="flex flex-row items-end justify-center items-center" slot="icons">
					<TopMenuOptions/>
					<InitialsAvatarIcon />
				</div>
			</SfcShellAppBar>
			<LeftNav />
			<SdfPageLayout>
				<div className="p-0 sm:p-3">
					<ToastList />
					<MarketplaceAssist>
						<BaseRoutes />
					</MarketplaceAssist>
				</div>
			</SdfPageLayout>
			<SessionIndicator />
		</SfcShell>
	);
}
